import { StatusTypes, ResultsTypes } from './types';

export const RESULTS_MAP: Record<ResultsTypes, string> = {
  [ResultsTypes.Unknown]: 'Неизвестно',
  [ResultsTypes.Confirmed]: 'Подтверждение',
  [ResultsTypes.Declined]: 'Отмена',
  [ResultsTypes.Rescheduled]: 'Перенос',
  [ResultsTypes.ClinicCancelled]: 'Отмена по инициативе клиента',
  [ResultsTypes.ClinicRescheduled]: 'Перенос по инициативе клиента',
};

export const STATUS_MAP: Record<StatusTypes, string> = {
  [StatusTypes.Unknown]: 'Обработка не начата',
  [StatusTypes.ErrorTimeout]: 'Нет ответа',
  [StatusTypes.ErrorBusy]: 'Номер занят',
  [StatusTypes.ErrorForbidden]: 'Номер запрещен',
  [StatusTypes.ErrorOther]: 'Прочие ошибки',
  [StatusTypes.ErrorRecognize]: 'Не распознана речь',
  [StatusTypes.ErrorPaketLoss]: 'Потеря пакетов данных',
  [StatusTypes.ErrorHangUp]: 'Досрочное завершение звонка',
  [StatusTypes.Connected]: 'Произведено подключение',
  [StatusTypes.RedirectToOperator]: 'Разговор переведен на оператора',
  [StatusTypes.CallFinishedNormally]:
    'Диалог с абонентом завершен в штатном режиме',
  [StatusTypes.CallFinishedWithTimeout]:
    'Диалог с абонентом не завершен в штатном режиме, модуль RoboCall принудительно завершил обработку',
  [StatusTypes.SynchronizationError]:
    'Ошибка синхронизации между каналом и сокетом',
};

export const medVoxParameters = {
  startDate: 'Filter.StartDate',
  endDate: 'Filter.EndDate',
  pageIndex: 'PageIndex',
  pageSize: 'PageSize',
  phone: 'Filter.Phone',
  clinicIds: 'Filter.Cliniclds',
  state: 'Filter.State',
};
